import React, {useContext, useRef} from 'react';
import {ReactSVG} from 'react-svg';
import {useTranslate} from '@computerrock/formation-i18n';
import './SearchNavigation.scss';
import CategoriesContext from '../CategoriesContext';
import {CLEAR_SEARCH} from '../../utils/ftemConstants';

const imageURL = `${process.env.PUBLIC_URL}/assets/icons/search.svg`;
const closeIconUrl = `${process.env.PUBLIC_URL}/assets/icons/close_search.svg`;

const SearchNavigation = ({handleSearch, searchTerm, setSearchTerm, closeDropDown}) => {
    const {search} = useContext(CategoriesContext);
    const setSearchedContext = search[1];
    const {createTranslateShorthand} = useTranslate();
    const translateScreen = createTranslateShorthand('categories_screen');

    const inputRef = useRef(null);
    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            setSearchedContext(event.target.value);
            closeDropDown(false);
            inputRef.current.blur();
        }
    };

    return (
        <>
            <div className="field sski-c-top-navigation-bar__search-bar">
                <p className="control has-icons-left has-icons-right mb-2">
                    <input
                        ref={inputRef}
                        className="input"
                        type="text"
                        placeholder={translateScreen('input_placeholder.search')}
                        aria-label={translateScreen('input_placeholder.search')}
                        value={searchTerm}
                        onChange={handleSearch}
                        onKeyDown={e => handleKeyDown(e)}
                    />
                    <span
                        className="icon is-small is-left"
                        onClick={() => searchTerm && (setSearchedContext(searchTerm), closeDropDown(false))}
                    >
                        <ReactSVG src={imageURL} />
                    </span>
                    {searchTerm && (
                    <span
                        className="icon is-small is-right"
                        onClick={() => {
                            setSearchTerm('');
                            setSearchedContext(CLEAR_SEARCH);
                        }}
                    >
                        <ReactSVG src={closeIconUrl} />
                    </span>
                    )}
                </p>
            </div>
            {searchTerm.length > 0
                ? (
                    <div className="sski-c-top-navigation-bar__search-bar_button_contaniner rise">
                        <button
                            className="button is-rounded is-fullwidth"
                            type="button"
                            onClick={() => { setSearchedContext(searchTerm); closeDropDown(false); }}
                        >
                            {translateScreen('button_label.search')}
                        </button>
                    </div>
                ) : <div className="divider mb-2" />
            }
        </>
    );
};

export default SearchNavigation;
